/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Home_Platforms_Mac_DescInputs */

const en_fc_home_platforms_mac_desc = /** @type {(inputs: Fc_Home_Platforms_Mac_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`One Universal DMG runs natively on Apple silicon and Intel Macs. Drag it to Applications and open it from there.`)
};

/**
* | output |
* | --- |
* | "One Universal DMG runs natively on Apple silicon and Intel Macs. Drag it to Applications and open it from there." |
*
* @param {Fc_Home_Platforms_Mac_DescInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_home_platforms_mac_desc = /** @type {((inputs?: Fc_Home_Platforms_Mac_DescInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Home_Platforms_Mac_DescInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_home_platforms_mac_desc(inputs)
});
export { fc_home_platforms_mac_desc as "fc.home.platforms.mac.desc" }